import React from 'react';
import styled from 'styled-components';
import media from '../../utils/media';
import { RichP3 } from '../Typography';
const ImageCaptionField = styled(RichP3) `
  font-size: 16px;
  line-height: 28px;
  margin: 20px auto;
  ${media.mobileM} {
    font-size: 14px;
    line-height: 22px;
  }
  ${media.smallTablet} {
    margin-bottom: 28px;
  }
`;
// TODO: Housekeeping
export const ImageCaption = ({ imageCaption, }) => {
    if (!imageCaption) {
        return null;
    }
    return (React.createElement(ImageCaptionField, { field: imageCaption }));
};
